<div class="grid field col-12">
    <div class="grid field col-12">
        <h1>Workbook Log</h1>
        @if (showSavingProgress || !everythingReady) {
            <p-progressSpinner></p-progressSpinner>
        }
    </div>
    @if (messages.length > 0) {
        <div class="grid field col-12">
            @for (m of messages; track $index) {
                <p-message
                    [severity]="m.severity"
                    >
                    {{ m.summary ? (m.detail ? m.summary + ': ' + m.detail : m.summary) : m.detail }}
                </p-message>
            }
        </div>
    }
    @if (everythingReady) {
        <div class="grid field col-12">
            <div class="col-12 md:col-2">
                <button pButton  (click)="navigateToJobDetails()" class="wb-action-button">
                    <i pButtonIcon class="fa fa-edit"></i>
                    <span pButtonLabel>Job Details</span>
                </button>
            </div>
            <div class="col-12 md:col-2">
                <button pButton  (click)="navigateToDashboard()" class="wb-action-button">
                    <i pButtonIcon class="fa fa-bar-chart"></i>
                    <span pButtonLabel>Dashboard</span>
                </button>
            </div>
            <div class="col-12 md:col-2">
                <button pButton  (click)="navigateToShiftSummaries()" class="wb-action-button">
                    <i pButtonIcon class="fa fa-clipboard-list"></i>
                    <span pButtonLabel>Shift Summary</span>
                </button>
            </div>
            <div class="col-12 md:col-2">
                <button pButton type="button" (click)="openWorkbookConfiguration()" class="wb-action-button wb-action-button--right">
                    <i pButtonIcon class="fa fa-cog"></i>
                    <span pButtonLabel>Configure</span>
                </button>
            </div>
            <div class="col-12 md:col-2">
                <button pButton type="button" (click)="dt.exportCSV()" class="wb-action-button wb-action-button--right">
                    <i pButtonIcon class="fa fa-download"></i>
                    <span pButtonLabel>Export</span>
                </button>
            </div>
            <div class="grid field col-12">
                <p-table #dt 
                    [columns]="scrollableCols" [resizableColumns]="true"
                    [scrollable]="true" [scrollHeight]="scrollHeight"
                    [frozenColumns]="frozenCols" frozenWidth="175px"
                    [value]="workbookLogs"  
                    [loading]="!workbookReady"
                    (onEditInit)="notifyChangesMade($event)">
                    <!-- (onEditComplete)="tableDataChanged($event)"> -->
                    <ng-template #colgroup let-columns>
                        <colgroup>
                            <!-- <col *ngFor="let col of columns" [style.width]="col.width" /> -->
                            <col *ngFor="let col of columns" [style.width]="setWidth(col)"/>
                        </colgroup>
                    </ng-template>
                    <ng-template #header let-columns>
                        <tr>
                            <!-- Addding 'pResizableColumn' here doesn't work properly -->
                            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'display':col.display, 'height':'100px', 'overflow':'hidden'}">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-workbookLog let-columns="columns">
                            <tr style="height:30px;">
                                <td *ngFor="let col of columns" [pEditableColumn]="workbookLog" [pEditableColumnField]="col.field" [ngStyle]="{'display':col.display}">
                                    @if (col.field != 'relative_time' && col.header != 'Timestamp') {
                                        <p-cellEditor>
                                            <ng-template #input>
                                                @if ((col.field != 'time') && (col.field != 'fluid_system') && (col.field != 'activity')) {
                                                    <input type="text" [(ngModel)]="workbookLog[col.field]"/>
                                                }
                                                @if (col.field == 'time') {
                                                    <p-date-picker
                                                        [(ngModel)]="workbookLog.calendarTime"
                                                        [showIcon]="true"
                                                        [showTime]="true"
                                                        [hourFormat]="'12'"
                                                        yearRange="2018:2038"
                                                        appendTo="body">
                                                    </p-date-picker>
                                                }
                                                @if (col.field == 'fluid_system') {
                                                    <p-select [options]="fluidSystems" [(ngModel)]="workbookLog[col.field]" placeholder="Select" appendTo="body"></p-select>
                                                }
                                                @if (col.field == 'activity') {
                                                    <p-select [options]="activities" [(ngModel)]="workbookLog[col.field]" placeholder="Select" appendTo="body"></p-select>
                                                }
                                            </ng-template>
                                            <ng-template #output>
                                                @if (col.field == 'time') {
                                                    <div class="wbCell">{{workbookLog.calendarTime | date: 'short'}}</div>
                                                } @else {
                                                    <div class="wbCell"
                                                        [pTooltip]="workbookLog[col.field]" tooltipPosition="top" tooltipEvent="hover">{{workbookLog[col.field]}}</div>
                                                }
                                            </ng-template>
                                        </p-cellEditor>
                                    }
                                    @if (col.field == 'relative_time') {
                                        <div>
                                            {{workbookLog[col.field]  | number:'1.1-2'}}
                                        </div>
                                    }
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template #summary>
                            <div class="grid field col-12">
                                <div class="grid field col-12" pTooltip="Editing of Old Workbook has been disabled.  Only jobs with new workbook can add or modify workbook data.">
                                    <button type="button" [disabled]="true" pButton (click)="addWorkbookLogRow()" class="wb-summary-button">
                                        <i pButtonIcon class="fa fa-plus"></i>
                                        <span pButtonLabel>Add</span>
                                    </button>
                                    <button [disabled]="true" type="button" pButton (click)="saveWorkbookChanges()" class="wb-summary-button">
                                        <i pButtonIcon class="fa fa-save"></i>
                                        <span pButtonLabel>Save</span>
                                    </button>
                                </div>
                            </div>
                                
                            </ng-template>
                    </p-table>
                </div>
        </div>
    }
</div>



@if (workbookReady) {
    <p-dialog header="Workbook Configuration Settings" [(visible)]="showWorkbookConfigurationDialog">
    <!-- Displayed Workbook Fields -->
    <div class="grid field col-12">
            <p-table #displayFieldsDT [value]="workbookConfiguration.displayFields ?? []">
                    <ng-template #colgroup>
                            <colgroup>
                                <col [style.width]="fieldNameWidth" />
                                <col [style.width]="buttonWidth" />
                            </colgroup>
                    </ng-template>
                    <ng-template #header>
                            <tr>
                                <th>Workbook Fields</th>
                                <th></th>
                            </tr>
                    </ng-template>
                    <ng-template #body let-field>
                        @if (field != 'time' && field != 'relative_time') {
                            <tr>
                                <td>{{field}}</td>
                                <td>
                                    <button pButton type="button" (click)="hideDisplayedField(field)" class="wb-dialog-button">
                                        <span pButtonLabel>Hide</span>
                                    </button>
                                </td>
                            </tr>
                        }
                    </ng-template>
            </p-table>
    </div>
    <!-- Available Workbook Fields -->
    <div class="grid field col-12">
        <p-table #availableFieldsDT [value]="['one row']">
                <ng-template #colgroup>
                        <colgroup>
                            <col [style.width]="fieldNameWidth" />
                            <col [style.width]="buttonWidth" />
                        </colgroup>
                </ng-template>
                <ng-template #header>
                        <tr>
                            <th>Add Fields</th>
                            <th></th>
                        </tr>
                </ng-template>
                <ng-template #body let-row>
                        <tr>
                            <td><p-select [options]="availableFieldOptions" [(ngModel)]="selectedAvailableField" placeholder="Select a Field" appendTo="body" class="wb-dropdown-full"></p-select></td>
                            <td>
                                <button pButton type="button" (click)="displayField()" class="wb-dialog-button">
                                    <span pButtonLabel>Add</span>
                                </button>
                            </td>
                        </tr>
                </ng-template>
        </p-table>
    </div>
    <!-- Add New Workbook Field -->
    <div class="grid field col-12">
        <p-table #createFieldsDT [value]="['one row']" [resizableColumns]="true">
                <ng-template #colgroup>
                        <colgroup>
                            <col [style.width]="createFieldWidth" />
                            <col [style.width]="createFieldIsTextWidth" />
                            <col [style.width]="createFieldButtonWidth" />
                        </colgroup>
                </ng-template>
                <ng-template #header>
                        <tr>
                            <th>Create Fields</th>
                            <th>Text?</th>
                            <th></th>
                        </tr>
                </ng-template>
                <ng-template #body let-row>
                        <tr>
                            <td><input type="text" pInputText [(ngModel)]="createdField" placeholder="New Field" class="wb-dialog-input"/></td>
                            <td><p-checkbox [(ngModel)]="createFieldIsText" binary="true"></p-checkbox></td>
                            <td>
                                <button pButton type="button" (click)="createField()" class="wb-dialog-button">
                                    <span pButtonLabel>Create</span>
                                </button>
                            </td>
                        </tr>
                </ng-template>
        </p-table>
    </div>
</p-dialog>
}
